import { render, staticRenderFns } from "./PerCluster.vue?vue&type=template&id=6c2a97c2"
import script from "./PerCluster.vue?vue&type=script&lang=js"
export * from "./PerCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports